import { ReactElement } from 'react';
import { POST_PATH, postList } from '~/constants/blog';

export const getResolvedPost = (url: string, locale: string) => {
  const post = postList.find(item => item.url === url);
  if (!post) return null;

  // Post locale is the same as site locale
  if (post.locale === locale) {
    return post;
  }

  // Post locale is differs from the site locale
  // Get post with needed locale
  const localizedPost = postList.find(item => item.id === post.id && item.locale === locale);

  return localizedPost;
};

// Used for the post multi-language url
export const getRoutePostLink = (path: string, locale: string) => {
  const url = POST_PATH.replace('[...path]', path);
  return `/${locale}${url}`;
};

type TranslationFunction = (key: string) => string;

interface LinkComponents {
  [key: number]: ReactElement;
}

export const generateLinkComponents = (
  t: TranslationFunction,
  start: number,
  end: number,
): LinkComponents =>
  Object.fromEntries(
    Array.from({ length: end - start + 1 }, (_, i) => {
      const linkNum = start + i;
      return [
        linkNum,
        // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
        <a key={linkNum} className="base-link" href={t(`link${linkNum}`)} rel="noreferrer" />,
      ];
    }),
  );
